var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flex-between",attrs:{"id":"top-bar"}},[_c('valpo-main-nav'),_vm._v(" "),_c('section',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{ name: 'Index'}}},[_c('valpo-logo')],1)],1),_vm._v(" "),_c('valpo-socialmedia')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5f9600","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValpoTopBar.vue
// module id = 118
// module chunks = 0